import { CBI_GUIDE_LINK_ROLES } from '@monoimin/constants';

import type { LinksFamily, PreparedGuideLink } from '@monoimin/sb-types';

export const pickCbiGuideLinkBySlug = (
  links: Array<LinksFamily<PreparedGuideLink>>,
  slug: string
) => {
  return links.reduce<{
    link: PreparedGuideLink | null;
    family: LinksFamily<PreparedGuideLink> | null;
    role: CBI_GUIDE_LINK_ROLES | null;
  }>(
    (acc, family) => {
      if (acc.link) {
        return acc;
      }

      const { parent, children } = family;

      const isParent = parent.slug === slug;

      if (isParent) {
        return {
          link: parent,
          family: family,
          role: CBI_GUIDE_LINK_ROLES.PARENT,
        };
      }

      const child = children.find((item) => {
        return item.slug === slug;
      });

      if (child) {
        return {
          link: child,
          family: family,
          role: CBI_GUIDE_LINK_ROLES.CHILD,
        };
      }

      return acc;
    },
    { link: null, family: null, role: null }
  );
};

export default pickCbiGuideLinkBySlug;
